export default {
  user: {},
  userLicence: {},
  device: {},
};
